/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createLN2 } from '../../factoriesAny.js';
export var LN2Dependencies = {
  BigNumberDependencies,
  createLN2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLN2.generated.js
// module id = 1391
// module chunks = 2